<div class="okay" [ngStyle]="style()">
    <div class="content">
        {{model().data.content}}
    </div>
    <div class="action">
        <button class="action-button" (click)="onOk(true)">
            <span>{{model().data.ok}}</span>
        </button>
        <button class="action-button" (click)="onOk(false)">
            <span>{{model().data.cancel}}</span>
        </button>
    </div>
</div>
